import { CSSProperties, useContext, useMemo } from "react";
import DashboardPageContext from "../DashboardPageContext";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import DashboardEnvContext from "../DashboardEnvContext";
import { ComponentProps } from "../types";

function Component({ component, evalJsText }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const dashboard = useContext(DashboardEnvContext);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const pageContext = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		return style;
	}, [component, exeMode]);
	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, pageContext.context]);

	const locatorArgs = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
	}, [component, exeMode]);

	return (
		<>
			<span {...args} style={style} {...locatorArgs}>
				{evalJsText(component.properties["text"], true)}
			</span>
		</>
	);
}

export default Component;
